/*ReactJS*/
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { Modal, Backdrop, Fade, Box, TextField } from '@material-ui/core';
import SelectSystemCode from '../Dropdown/SelectSystemCode';
import Button from '../Buttons/Button';
import Text from '../Typography/Text';
import { dateProtoObjectToString } from '../../services/ConvertService';
import fontFamily from '../../assets/css/fonts';
import color from '../../assets/css/colors';
import InputMask from 'react-input-mask';
import SelectTaxCountry from '../../components/Dropdown/SelectTaxCountry';
import { SelectState } from '../AutoComplete/SelectSystemCode';

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 550,
    width: '100%',
    margin: '0 auto',
    float: 'clear',
  },
  fadeModalMd: {
    maxWidth: 800,
    width: '100%',
    padding: '25px 30px 30px 30px',
    margin: '0px auto',
    backgroundColor: '#ffffff',
    border: 'none',
    borderRadius: 5,
    boxShadow: '0px 0px 10px #333333',
    boxSizing: 'border-box',
    outline: 'none',
    overflowY: 'auto',
    maxHeight: '90vh',
  },
  modalHeader: {
    backgroundColor: 'white',
    padding: 25,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    display: 'flex',
    '& div:nth-child(1)': {
      flex: 1,
    },
    '& div:nth-child(2)': {
      flex: 'none',
      '& .MuiIconButton-root': {
        borderRadius: 5,
        padding: 10,
        '&:hover svg path': {
          fill: color.primary.main,
        },
      },
      '& svg:last-child': {
        width: 15,
        height: 15,
      },
    },
  },
  modalBody: {
    backgroundColor: 'white',
    padding: '0px 25px 25px 25px',
    fontFamily: fontFamily.headers,
    '& p': {
      fontSize: 16,
      lineHeight: '24px',
    },
  },
  modalFooter: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    backgroundColor: 'white',
    padding: '0px 25px 25px 25px',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    position: 'relative',
    '& button': {
      width: 'auto',
    },
  },
  closeButton: {
    '& button': {
      marginTop: '-4px !important',
    },
  },
  accordionDetails: {
    display: 'block !important',
    padding: '0px 20px 25px 20px !important',
  },
  accordion: {
    borderRadius: '5px !important',
    boxShadow: '0px 1px 5px -2px #cdcfdd !important',
    border: '1px solid #efeff0 !important',
  },
  tabBody: {
    minWidth: '100%',
    padding: '0px 6px',
  },
}));

export default function IdentificationModal({
  onClose: handleClose,
  open: isOpen,
  importMode: isImport,
  value,
  loading,
}) {
  const classes = useStyles();
  const [modalData, setModalData] = useState({
    ownerId: value.ownerId,
    type: '',
    id: '',
    countryOfIssuance: 'US',
    issueDate: '',
    expirationDate: '',
    status: 'Active',
    state: '',
  });
  const [isEdit, setIsEdit] = React.useState(false);
  const [maskValue, setMaskValue] = React.useState('999999999');
  const taxIdMaskRef = React.createRef();

  console.log(value);
  useEffect(() => {
    if (isOpen) {
      let valueCopy = { ...value };
      setModalData({ ...valueCopy });

      if (value.identificationId) {
        setIsEdit(true);
      }

      handleTaxIdMask(value.type);
    }
    // eslint-disable-next-line
  }, [isOpen, value]);

  const handleTaxIdMask = (type) => {
    if (type === 'SSN') {
      setMaskValue('999-99-9999');
    } else if (type === 'TIN') {
      setMaskValue('99-9999999');
    } else if (
      [
        'Passport',
        'International TIN',
        'Driver License',
        'Others',
        'Other Government Id',
        'Foreign Tax Id',
        'LEI',
      ].includes(type)
    ) {
      setMaskValue('*'.repeat(30));
    } else if (type === 'GIIN') {
      setMaskValue('******.*****.**.***');
    } else {
      setMaskValue('*'.repeat(9));
    }
  };

  const handleChange = (e) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;

    if (input.name === 'type') {
      modalData.countryOfIssuance = ['SSN', 'TIN'].includes(input.value)
        ? 'US'
        : modalData.countryOfIssuance;

      if (input.value === 'GIIN' && modalData.issueDate) {
        const issueDate = new Date(modalData.issueDate);
        issueDate.setFullYear(issueDate.getFullYear() + 1);
        modalData.expirationDate = issueDate.toISOString().slice(0, 10);
      }
    }

    if (input.name === 'issueDate' && modalData.type === 'GIIN') {
      const issueDate = new Date(input.value);
      issueDate.setFullYear(issueDate.getFullYear() + 1);
      modalData.expirationDate = issueDate.toISOString().slice(0, 10);
    }

    setModalData({
      ...modalData,
      [input.name]: ['id'].includes(input.name) ? input.value.toUpperCase() : input.value,
    });
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={isOpen}
      onClose={() => handleClose()}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={isOpen}>
        <div className={classes.fadeModalMd}>
          <Text
            id="transition-modal-title"
            variant="h2"
            label={isEdit ? 'Edit Identification' : 'Add New Identification'}
          />
          <Box mt={5}>
            <form className={classes.modalForm} noValidate autoComplete="off">
              <div>
                <div className="grd-row">
                  <div className="grd-cell">
                    <SelectSystemCode
                      required={true}
                      name="type"
                      label="Type"
                      type="Identification"
                      value={modalData.type}
                      onChange={(e) => {
                        handleTaxIdMask(e.target.value);
                        handleChange(e);
                      }}
                    ></SelectSystemCode>
                  </div>
                  <div className="grd-cell">
                    <InputMask
                      mask={maskValue}
                      maskChar={''}
                      value={modalData.id}
                      ref={taxIdMaskRef}
                      beforeMaskedValueChange={(newState, oldState) => {
                        if (newState.value !== oldState.value) {
                          handleChange({
                            currentTarget: {
                              name: 'id',
                              value: newState.value,
                            },
                          });
                        }
                        return {
                          value: newState.value,
                          selection: newState.selection,
                        };
                      }}
                    >
                      {() => (
                        <TextField
                          fullWidth={true}
                          required={true}
                          id="id"
                          name="id"
                          label="ID"
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                    </InputMask>
                  </div>
                </div>
                <div className="grd-row">
                  <div className="grd-cell">
                    <SelectTaxCountry
                      required={true}
                      disabled={
                        (modalData.type === 'SSN' || modalData.type === 'TIN') &&
                        modalData.countryOfIssuance === 'US'
                      }
                      name="countryOfIssuance"
                      label="Country Of Issuance"
                      value={modalData.countryOfIssuance}
                      onChange={(selected) => {
                        setModalData({
                          ...modalData,
                          countryOfIssuance: selected?.code,
                        });
                      }}
                    ></SelectTaxCountry>
                  </div>
                  <div className="grd-cell">
                    {modalData.type === 'SSN' || modalData.type === 'Foreign Tax Id' ? (
                      <div className="grd-cell">
                        <SelectSystemCode
                          required={true}
                          name="status"
                          label="Status"
                          type="Status"
                          subType="Client Info Setup"
                          value={modalData.status}
                          onChange={handleChange}
                        ></SelectSystemCode>
                      </div>
                    ) : (
                      <div className="grd-cell">
                        <SelectState
                          required={modalData.countryOfIssuance === 'US'}
                          name="state"
                          label="State"
                          value={modalData.state}
                          onChange={handleChange}
                          country={modalData.countryOfIssuance}
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div className="grd-row">
                  <div className="grd-cell">
                    <TextField
                      fullWidth
                      required={
                        !(
                          modalData.type === 'TIN' ||
                          modalData.type === 'SSN' ||
                          modalData.type === 'Foreign Tax Id' ||
                          modalData.type === 'International TIN' ||
                          modalData.type === 'WP-EIN' ||
                          modalData.type === 'QI-EIN'
                        )
                      }
                      name="issueDate"
                      label="Issue Date"
                      type="date"
                      value={modalData.issueDate}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                  <div className="grd-cell">
                    {!['SSN', 'Foreign Tax Id'].includes(modalData.type) &&
                    (modalData.type === 'TIN' ||
                      modalData.type === 'International TIN' ||
                      modalData.type === 'WP-EIN' ||
                      modalData.type === 'QI-EIN') ? (
                      <SelectSystemCode
                        required={true}
                        name="status"
                        label="Status"
                        type="Status"
                        subType="Client Setup"
                        value={modalData.status}
                        onChange={handleChange}
                      ></SelectSystemCode>
                    ) : (
                      <TextField
                        fullWidth
                        required={
                          ![
                            'SSN',
                            'Foreign Tax Id',
                            'TIN',
                            'International TIN',
                            'WP-EIN',
                            'QI-EIN',
                          ].includes(modalData.type)
                        }
                        name="expirationDate"
                        label="Expiration Date"
                        type="date"
                        value={modalData.expirationDate}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  </div>
                </div>
                <div className="grd-row">
                  {modalData.type === 'TIN' ||
                  modalData.type === 'SSN' ||
                  modalData.type === 'Foreign Tax Id' ||
                  modalData.type === 'International TIN' ||
                  modalData.type === 'WP-EIN' ||
                  modalData.type === 'QI-EIN' ? (
                    <div className="grd-cell"></div>
                  ) : (
                    <div className="grd-cell">
                      <SelectSystemCode
                        required={true}
                        name="status"
                        label="Status"
                        type="Status"
                        subType="Client Setup"
                        value={modalData.status}
                        onChange={handleChange}
                      ></SelectSystemCode>
                    </div>
                  )}
                  <div className="grd-cell"></div>
                </div>
              </div>
              <div className={classes.modalFooter}>
                <div className="grd-row">
                  <div className="grd-cell-none" style={{ marginRight: 10 }}>
                    <Button
                      disabled={loading}
                      color="primary"
                      label="Close"
                      onClick={() => {
                        handleClose();
                      }}
                    />
                  </div>
                  <div className="grd-cell-none">
                    <Button
                      disabled={loading}
                      loading={loading}
                      color="secondary"
                      label={loading ? 'Saving...' : 'Save'}
                      onClick={() => {
                        handleClose(modalData, isEdit);
                      }}
                    />
                  </div>
                </div>
              </div>
            </form>
          </Box>
        </div>
      </Fade>
    </Modal>
  );
}
